import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import bellIcon from "../../../assets/images/bellIcon.svg";
import closeIcon from "../../../assets/images/CloseIcon.svg";
import { history } from "helpers";
import moment from "moment";
import StockReleasedComp from "../DigitalSignature/StockReleasedComp/StockReleasedComp";

import {
  Container,
  Tooltip,
  OverlayTrigger,
  Button,
  Row,
  Col,
} from "react-bootstrap";
import dot from "../../../assets/images/notificationDot.svg";
import UploadAdditionalForm from "component/User/SubmitRequestComp/UploadAdditionalDocument/UploadAdditionalForm";
import { notificationUpdate } from "service/Auth";
import { useSelector } from "react-redux";
import { Toast } from "service/toast";
import { getBidDetailsAPi } from "service/Cog";

const NotificationBar = ({
  showTooltip,
  setShowTooltip,
  onHide,
  notification,
  refresh,
}) => {
  const role = useSelector((state) => state.home.role);
  const [showAllNotifications, setShowAllNotifications] = useState(false);
  const [showTruckModal, setShowTruckModal] = useState(false);
  const [truckData, setTruckData] = useState({})

  const handleToggleTooltip = () => {
    setShowAllNotifications(false);

    setShowTooltip(!showTooltip);
  };

  const handleNavigateNotificationUpload = (item) => {

    if (item?.type === "FINANCE_TEAM_INVOICE_UPLOADED") {
      const upperRole = String(role).toUpperCase();
      if (upperRole === "CUSTOMER" || upperRole === "GRAIN MANAGER") {
        setTruckData(item?.extra?.getReleaseUpdateDetails);
        setShowTruckModal(true);
        onHide();
      }
    }

    if (item?.type === "PURCHASE_CONFIRMATION") {
      if (role == "CUSTOMER") {
        history.push({
          pathname:
            "/admin/transactions/purchase/purchase-request/purchase-confirm",
          state: {
            purchaseOrderIds: item?.extra?.purchaseOrderId,
            proposalId: item?.extra?.proposalId,
          },
        });
      }
      onHide();
    }

    if (item?.type === "INVOICE_UPLOAD_REQUESTED") {
      const upperRole = String(role).toUpperCase();
      if (upperRole === "FINANCE - TEAM MEMBER") {
        history.push({
          pathname: "/admin/value-chain-manage/invoice",
          state: {
            extra: item?.extra
          }
        })
        onHide();
      }
    }

    if (item.type === "RE-UPLOAD DOCUMENTS") {
      if (!item.extra.isDeleted) {
        history.push("/admin/submit-request/additional-document", {
          notifcation: item,
        });
        onHide();
      }
    }

    if (item.type === "PROPOSAL_CREATED") {
      if (role == "CUSTOMER") {
        history.push({
          pathname: "/admin/proposal-order",
          state: {
            data: item?.extra
          }
        });
        onHide();
      } else {
        history.push("/admin/value-chain-manage/approvals");
        localStorage.setItem("isNotification", true);
        onHide();
      }
    }

    if (item.type === "CONTRACT_SUBMITED") {
      history.push({
        pathname: "/admin/transactions/purchase/purchase-request",
        state: {
          commodity: item?.requiredCommodity,
          variety: item?.requiredVariety,
          contractId: item?.contractId,
        },
      });
      onHide();
    }

    if (item.type === "REMINDER TO SEND BID") {
      history.push("/admin/bidQuotation/ongoingBids");
      onHide();
    }

    if (item.type === "REQUEST_FOR_BID_SUBMISSION") {
      handleGetBidData(item?.extra?.biddingId, item)
    }
  };

  const handleNotificationClick = async (item) => {
    if (item?.isRead === false) {
      await readNotification(item?.notificationId, true);
    }
    handleNavigateNotificationUpload(item);
  };

  const handleGetBidData = async (id, item) => {

    const currentTime = moment();
    const closingDate = moment(item?.extra?.closingDate).format("YYYY-MM-DD");
    const bidClosingTime = moment(
      `${closingDate} ${item?.extra?.bidClosingTime}`,
      "YYYY-MM-DD HH:mm"
    );

    try {
      const params = {
        id: id,
      };
      const response = await getBidDetailsAPi(params);
      if (response?.data?.status === 200) {
        if (currentTime.isAfter(bidClosingTime)) {
          Toast({ type: "error", message: "The bid has already closed" });
        } else {
          history.push({
            pathname: "/admin/bidQuotation/ongoingBids/bidNow",
            state: response?.data?.data,
          });
          onHide();
        }
      }
    } catch (e) {
      console.log("e", e);
    }
  };

  const handlehide = () => {
    setShowAllNotifications(false);
    onHide();
  };

  const readNotification = async (id, status) => {
    try {
      const body = {
        isRead: status,
      };
      const response = await notificationUpdate(body, id);
      if (response.status === 200) {
        refresh();
      }
    } catch (e) {
      console.log("e", e);
    }
  };

  const handleAllRead = async () => {
    const isItemArray = Array.isArray(notification);
    const filterList =
      Boolean(isItemArray) &&
      notification
        ?.filter((x) => x.isRead == false)
        ?.map((y) => y.notificationId);

    let body = {
      isRead: true,
      id: filterList,
    };

    let finalPayload = body;
    const response = await notificationUpdate(body);
    if (response.status === 200) {
      refresh();
    }
  };

  const tooltipContent = (
    <Tooltip style={{ opacity: "1" }} id="notification-tooltip">
      <div className="d-flex align-items-center justify-content-between pt-2 pb-3 handhover">
        <h6>
          Notifications {"( "}
          {notification?.filter((x) => x.isRead === false)?.length}
          {" )"}
        </h6>
        <img
          onClick={handlehide}
          src={closeIcon}
          alt="Close"
          className="noti-close-img"
        />
      </div>
      {notification?.filter((x) => x.isRead === false)?.length ? (
        <div className="w-100 text-end">
          <span
            className=" text-end mark-notification"
            onClick={() => {
              handleAllRead();
            }}
          >
            Mark as all read
          </span>
        </div>
      ) : (
        ""
      )}
      {showAllNotifications
        ? notification?.map((notificationItem, index) => (
          <div key={index}>
            <div className="tooltip-content pb-3">
              {notificationItem?.isRead === false && (
                <div className="mr-3 pt-2">
                  <img src={dot} alt="" />
                </div>
              )}
              <div className="pt-3">
                <p
                  onClick={() => handleNotificationClick(notificationItem)}
                  className={
                    notificationItem?.extra?.isDeleted || notificationItem?.isRead
                      ? "handhovernonclick"
                      : "handhover"
                  }
                >
                  {notificationItem.title}
                </p>
                <h2
                  onClick={() => handleNotificationClick(notificationItem)}
                  className={
                    notificationItem?.extra?.isDeleted || notificationItem?.isRead
                      ? "handhovernonclick"
                      : "handhover"
                  }
                >
                  {notificationItem.content
                    .split("<br>")
                    .map((line, index) => (
                      <React.Fragment key={index}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                </h2>
                <h2>
                  {" "}
                  {moment(notificationItem.createdAt).format(
                    "MMM Do YY | h:mm a"
                  )}
                </h2>
                {notificationItem?.isRead === false ? (
                  <div
                    onClick={() =>
                      readNotification(notificationItem?.notificationId, true)
                    }
                    className="pt-1 mark-notification"
                  >
                    Mark As Read
                  </div>
                ) : (
                  <div
                    onClick={() =>
                      readNotification(
                        notificationItem?.notificationId,
                        false
                      )
                    }
                    className="pt-1 mark-notification"
                  >
                    Mark As Unread
                  </div>
                )}
                {/* <div className="pt-3">
                  <p
                    onClick={() => {
                      handleNavigateNotificationUpload(notificationItem);
                    }}
                    className={
                      notificationItem?.extra?.isDeleted
                        ? "handhovernonclick"
                        : "handhover"
                    }
                  >
                    {notificationItem.title}
                  </p>
                  <h2
                    onClick={() =>
                      handleNavigateNotificationUpload(notificationItem)
                    }
                    className={
                      notificationItem?.extra?.isDeleted
                        ? "handhovernonclick"
                        : "handhover"
                    }
                  >
                    {notificationItem.content
                      .split("<br>")
                      .map((line, index) => (
                        <React.Fragment key={index}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                  </h2>
                  <h2>
                    {" "}
                    {moment(notificationItem.createdAt).format(
                      "MMM Do YY | h:mm a"
                    )}
                  </h2>
                  {notificationItem?.isRead === false ? (
                    <div
                      onClick={() =>
                        readNotification(
                          notificationItem?.notificationId,
                          true
                        )
                      }
                      className="pt-1 mark-notification"
                    >
                      Mark As Read
                    </div>
                  ) : (
                    <div
                      onClick={() =>
                        readNotification(
                          notificationItem?.notificationId,
                          false
                        )
                      }
                      className="pt-1 mark-notification"
                    >
                      Mark As Unread
                    </div>
                  )}
                </div> */}
              </div>
            </div>
            <hr className="m-0" />
          </div>
        ))
        : notification?.slice(0, 2)?.map((notificationItem, index) => (
          <div key={index}>
            <div className="tooltip-content pb-3">
              {notificationItem?.isRead === false && (
                <div className="mr-3 pt-2">
                  <img src={dot} alt="" />
                </div>
              )}
              <div className="pt-3">
                <p
                  onClick={() => handleNotificationClick(notificationItem)}
                  className={
                    notificationItem?.extra?.isDeleted || notificationItem?.isRead
                      ? "handhovernonclick"
                      : "handhover"
                  }
                >
                  {notificationItem.title}
                </p>
                <h2
                  onClick={() => handleNotificationClick(notificationItem)}
                  className={
                    notificationItem?.extra?.isDeleted || notificationItem?.isRead
                      ? "handhovernonclick"
                      : "handhover"
                  }
                >
                  {notificationItem.content
                    .split("<br>")
                    .map((line, index) => (
                      <React.Fragment key={index}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                </h2>
                <h2>
                  {" "}
                  {moment(notificationItem.createdAt).format(
                    "MMM Do YY | h:mm a"
                  )}
                </h2>
                {notificationItem?.isRead === false ? (
                  <div
                    onClick={() =>
                      readNotification(notificationItem?.notificationId, true)
                    }
                    className="pt-1 mark-notification"
                  >
                    Mark As Read
                  </div>
                ) : (
                  <div
                    onClick={() =>
                      readNotification(
                        notificationItem?.notificationId,
                        false
                      )
                    }
                    className="pt-1 mark-notification"
                  >
                    Mark As Unread
                  </div>
                )}
              </div>
            </div>
            <hr className="m-0" />
          </div>
        ))}

      {notification.length > 3 ? (
        <span
          onClick={() => setShowAllNotifications(!showAllNotifications)}
          className="mb-2 static-text"
        >
          {showAllNotifications ? "Show less" : "View all notifications"}
        </span>
      ) : (
        ""
      )}
    </Tooltip>
  );

  return (
    <div>
      <OverlayTrigger
        placement="bottom"
        overlay={tooltipContent}
        show={showTooltip}
        onHide={onHide}
        trigger={["click"]}
        rootClose
      >
        <div className="position-relative">
          <img
            src={bellIcon}
            width={40}
            className="mx-md-3 mx-2 cursor-pointer profile_icon"
            onClick={handleToggleTooltip}
            alt=""
          />

          {notification?.filter((x) => x.isRead === false)?.length > 0 ? (
            <div className="notification-badge">
              {notification?.filter((x) => x.isRead === false)?.length}
            </div>
          ) : (
            ""
          )}
        </div>
      </OverlayTrigger>
      <StockReleasedComp open={showTruckModal} releaseUpdateId={truckData?.releaseUpdateId} releaseOrderId={truckData?.releaseOrderId} onCancel={() => setShowTruckModal(false)} />
    </div>
  );
};

export default NotificationBar;

// 
